import { Button, message, Modal } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import WarehouseService from "../../services/Warehouses/WarehouseService";
import { useState } from "react";
import ConfirmDeleteButton from "../../common/actions/ConfirmDeleteButton";

const WarehouseDockDelete = ({ warehouseId, id, handleCancel }) => {
  const queryClient = useQueryClient();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { mutate } = useMutation({
    mutationFn: async () => await WarehouseService.deleteDock(warehouseId, id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [warehouseId, "docks"] });
      handleCancel();
      message.success("Dock deleted successfully!");
    },
    onError: async (error) => {
      setIsModalOpen(false);
      message.error(`Failed to delete dock. ${error?.response?.data?.message}, Please try again.`);
    }
  });

  return (
    <>
      <ConfirmDeleteButton  title="Are you sure you want to delete this zone?" onConfirm={mutate} />
    </>
  );
};

export default WarehouseDockDelete;